import { Journey } from '../../lib/types/models/product/journey'
import { JourneyRequest } from '../../lib/types/models/product/journey-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createJourney(data: JourneyRequest): Promise<Journey> {
  return restApiClient
    .url(constructApiUrl(API.products.createJourney.url, null))
    .post<Journey, JourneyRequest>(data)
}
